import { useState } from "react";
import { IoSearch } from "react-icons/io5";
//import { IoHammer } from "react-icons/io5";
//import { IoHeart, IoHeartOutline } from "react-icons/io5";
//import { Heart } from "lucide-react";
import { ShoppingCart } from "lucide-react";
import { search } from "ionicons/icons";
import { Link, NavLink } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from './Context';
import "./Search.css"
import AllProducts from "./AllProducts";
//import NewArrivals from "./NewArrivals";
//import BestSellers from "./BestSellers";

export default function Search() {
    const info = useContext(AuthContext)

          const [carData, setCarData] = useState([])



 
  const [disappear, setDissaper] = useState(false)
  

   const [searchInput, setSearchInput] = useState("")
  const [isShown, setIsShown] = useState(false)
  const handleChange = (event) => {
    //setIsShown(true)
    if (event.target.value.length < 1) {
      setIsShown(false)

    } else {
      setIsShown(true)

    }

    setCarData(info)
    setSearchInput(event.target.value)


  }

  const [category ,setCategory]=useState("Ian")
  
  
  
  const searchArray = carData.filter(search => search.name.toLowerCase().includes(searchInput))
  const searchResults = searchArray.map(card =>
    <NavLink to={`/products/${card.id}`} className="search-link">
    <div className="seach-Card">
        <div className="search-image-div"><img src={card.image} loading="lazy"/></div>
        <div className="search-image-description">
<p>{card.name}</p>
<p className="pricee">{new Intl.NumberFormat("en-KE",{
                                                style:"currency",
                                                currency:"KES",
                                                minimumFractionDigits:0,
                                            }).format(card.price)}</p>


        </div>

    </div>
    </NavLink>
  )


  const [isSearched, setIsSearched] = useState(false)

 const  dynamicHint=()=>{
    if(searchArray.length<1){
      return <p className="search-result-hint">No Results</p>
    }else{
      return <p className="search-result-hint">Top  results for "<span>{searchInput}</span>"</p>
    }
  }

  return (
    <>
      <section className={`search-sectionn ${disappear ? "dissapear" : ""}`}>

        <div className={isSearched ? "form-active" : "search-form"}>
          <input type="text" className="home2-search-input" autoCapitalize="none" id="search-input"
            placeholder="search for a furniture" onChange={handleChange} onClick={() => { setIsSearched(true) }} onBlur={()=>{setIsSearched(false)}}/>
          <button className="home2-search-btn" onClick={() => { setIsSearched(true) }}><IoSearch size={40} className="fa-magnifying-glass" /></button>
        </div>
        {isShown &&  dynamicHint()}
        
        
                <div class="products__container grid ">
          {isShown && searchResults}


</div>
        <h1 className="suggestion-heading">Morara Homes Top Furnitures</h1>

        <div className="search-links">
          <NavLink className="span" to="/sofas"  ><img src="https://i.pinimg.com/1200x/4b/ee/ba/4beeba8c977d00ec5b74edea86e94319.jpg"/><span> Comfy Sofas</span></NavLink>

          <NavLink className="span" to="/beds" ><img src="https://i.pinimg.com/736x/b9/b0/7e/b9b07e9c18b0df1de1d98c7df7a25f91.jpg"/><span>Premium Beds</span></NavLink>
          <NavLink className="span" to="/tables" ><img src="https://i.pinimg.com/736x/1c/96/67/1c966799778937014266821856a4d264.jpg"/><span>Elegant Dining Tables</span></NavLink>
         





        </div>



      
      </section>

      <AllProducts/>
      
    </>
  )
}